


























































































































































































import ClassifiedMapSearchResults from '~/components/car/classifieds/map-search/results/ClassifiedMapSearchResults.vue'
import ClassifiedMapSearchMap from '~/components/car/classifieds/map-search/ClassifiedMapSearchMap.vue'
import CFacetsFloatingButton from '~/components/shared/configurable/button/CFacetsFloatingButton.vue'
import DefaultSearchFacets from '~/components/car/classifieds/search/facets/Facets.vue'
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import {
  SET_PAGE,
  SET_PARAM,
  SET_SHOW_SELLERS,
  SET_MAP_SEARCH_FLAG
} from '~/store/modules/shared/classifieds/search/mutation-types'
import ClassifiedMapSearchFloatingMapButton from '~/components/car/classifieds/map-search/ClassifiedMapSearchFloatingMapButton.vue'
import CBottomDrawer from '~/components/shared/configurable/CBottomDrawer.vue'
import CClassifiedCarouselItem from '~/components/shared/configurable/classified/image/CClassifiedCarouselItem.vue'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import MapLocationSearchHandler from '~/components/car/classifieds/search/facets/handlers/MapLocationSearchHandler.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import CClassifiedCompareCounter from '~/components/shared/configurable/classified/compare/CClassifiedCompareCounter.vue'
import { setUrlParam } from '~/utils/http'
import { ClusterMarker } from '~/models/search/map/types'
import ClassifiedMapSearchResultsClusterModal from '~/components/car/classifieds/map-search/results/ClassifiedMapSearchResultsClusterModal.vue'
import { formatNumber } from '~/utils/number'
import { toCamelCase } from '~/utils/object'
import CMobileSidebar from '~/components/shared/configurable/CMobileSidebar.vue'
import MobileSideBarHeader from '~/components/car/classifieds/search/mobile/MobileSideBarHeader.vue'
import MobileSideBarFooter from '~/components/car/classifieds/search/mobile/MobileSideBarFooter.vue'
import { PAGE_NS } from '~/store/modules/shared/page/state'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { capitalizeString } from '~/utils/string'
import { mapDeps } from '~/plugins/dependency-container/utils'
import CompareService from '~/services/compare/CompareService'
import CFacetButton from '~/components/shared/configurable/button/CFacetButton.vue'
import MapSearchService from '~/services/search/MapSearchService'
import CPostcodeAutocomplete from '~/components/shared/configurable/form/autocomplete/CPostcodeAutocomplete.vue'
import { facetChanged } from '~/store/modules/shared/classifieds/search/action-types'
import UrlHistoryService from '~/services/url/history/UrlHistoryService'
import ViewTypeSelector from '~/components/car/classifieds/search/results/header/ViewTypeSelector.vue'
import SelectedHandlers from '~/components/car/classifieds/search/results/header/SelectedHandlers.vue'
import { getRandomArrayItem } from '~/utils/array'
import { SET_CLASSIFIED_ID } from '~/store/modules/shared/classifieds/view/mutation-types'
import {
  defineComponent,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CMobileSidebar,
    MobileSideBarHeader,
    MobileSideBarFooter,
    DefaultSearchFacets,
    ClassifiedMapSearchMap,
    CFacetsFloatingButton,
    CBottomDrawer,
    CClassifiedCarouselItem,
    ClassifiedMapSearchResults,
    ClassifiedMapSearchFloatingMapButton,
    MapLocationSearchHandler,
    CClassifiedCompareCounter,
    ClassifiedMapSearchResultsClusterModal,
    CFacetButton,
    CPostcodeAutocomplete,
    ViewTypeSelector,
    SelectedHandlers,
    PickupLocationSearchHandler: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/search/facets/handlers/PickupLocationSearchHandler.vue'
      )
    )
  },
  props: {
    rows: { type: Array, required: true },
    loadingResults: { type: Boolean, default: false },
    currentPage: { type: Number, required: true },
    sort: { type: Array, default: () => [] }
  },
  data() {
    return {
      isDrawerOpen: false,
      loadingClassified: false,
      isCarouselItemVisible: false,
      icons: {
        filterIcon: faFilter
      },
      marker: null,
      isClusterResultsModalVisible: false,
      clusterGeolocation: null,
      showLink: true,
      postcode: {
        name: '',
        country_code: ''
      },
      disablePopstate: false, // when user navigate from browser back and forward
      isMapLoading: true
    }
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      classified: state => toCamelCase(state.classified),
      currentUser: state => toCamelCase(state.currentUser)
    }),
    ...mapState(CLASSIFIED_SEARCH_NS, {
      rowsTotalClassifieds: state => state.pagination.total,
      showMobileFacets: state => state.showMobileFacets,
      params: state => state.params,
      currentRoute: state => state.currentRoute,
      categoryIds: state => state.categoryIds,
      isMapSearch: state => state.flags.isMapSearch
    }),
    ...mapGetters(CLASSIFIED_SEARCH_NS, {
      facetCount: 'getFacetsCount',
      getFacetByName: 'getFacetByName',
      inPlotSearch: 'inPlotSearch'
    }),
    mapLocationHandler() {
      return this.getFacetByName('location')
    },
    postcodeHandler() {
      return this.getFacetByName('postcode')
    },
    pickupLocationHandler() {
      return this.getFacetByName('pickup_location')
    },
    pickupLocationPlaceholder() {
      const randomCity = getRandomArrayItem([
        this.$t('athens::location'),
        this.$t('rhodos::location'),
        this.$t('chania::location')
      ])

      return `${this.$t('pickup location')} ${this.$t(
        'e.g.'
      ).toLowerCase()} ${randomCity}`
    },
    ...mapDeps({
      compareService: CompareService,
      historyService: UrlHistoryService
    }),
    title(): object {
      const formatedNumber = formatNumber(this.rowsTotalClassifieds)
      const title = capitalizeString(
        this.$dep(MapSearchService).resultsTitle(
          this.hasParamShowSellers,
          this.isMapSearch,
          this.categoryIds,
          formatedNumber
        )
      )
      const [prefix, number, suffix] = title.split(' ')
      return { prefix, number, suffix }
    },
    scrollContainer() {
      if (this.$refs?.drawer) {
        return this.$refs.bottomDrawer.$el
      }

      return null
    },
    normalizedRows() {
      return toCamelCase(this.rows)
    },
    fullPath() {
      return `https://car.gr${this.$route.fullPath}`
    },

    locationParam() {
      return this.params.location2
    },
    hasParamShowSellers(): boolean {
      const showSellers = this.params['show-sellers']
      if (Array.isArray(showSellers)) {
        return !!this.params['show-sellers']?.length
      }
      return !!this.params['show-sellers']
    }
  },
  watch: {
    currentRoute() {
      if (this.params['show-sellers']) {
        this.marker = null
      }
    },
    currentPage() {
      if (this.isDrawerOpen) {
        this.scrollResultsToTop()
      }
    },
    sort() {
      if (this.isDrawerOpen) {
        this.scrollResultsToTop()
      }
    },
    facetCount() {
      this.scrollResultsToTop()
    },
    locationParam(newValue) {
      if (newValue) {
        this.handleClosestLocation()
      }
    },
    'params.postcode'(newVal: [], oldVal: []) {
      if (newVal?.length && newVal?.toString() !== oldVal?.toString()) {
        this.handleClosestLocation()
      }
    },
    params() {
      if (
        this.params['show-clusters']?.length &&
        this.params?.cgeolocation?.length
      ) {
        this.isClusterResultsModalVisible = true
      }
    },
    postcodeHandler() {
      this.setPostcodeData()
    },
    $route(to, from) {
      if (
        from.name === '__classifieds_view_plot_alt' &&
        to.name === '__classifieds_search_plot_map'
      ) {
        this.disablePopstate = true
        this.setPostcodeData()
        if (to.query.csp) {
          setTimeout(() => {
            this.handleScrollToClassified(parseInt(to.query.csp, 10))
          }, 300)
        }
      }
    }
  },
  beforeMount() {
    this.setPostcodeData()
  },
  deactivated() {
    this.toggleResultsModal(false)
  },
  activated() {
    if (this.$refs?.map?.invalidateSizeWithDisabledBounds) {
      this.$refs.map.invalidateSizeWithDisabledBounds()
    }
    this.toggleResultsModal()
  },
  mounted() {
    window.addEventListener('popstate', this.onPopstate, false)
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.onPopstate, false)
    this.setMapSearchFlag(false)
  },
  methods: {
    handleCloseAgentProfile() {
      this.$parent.handleCloseAgentProfile(this.$refs.map.grGeolocation)
    },
    ...mapActions(CLASSIFIED_SEARCH_NS, {
      search: 'search',
      toggleMobileFacets: 'toggleMobileFacets',
      searchForResults: 'searchForResults',
      updateUrl: 'updateUrl',
      updateRoutes: 'updateRoutes',
      changePage: 'changePage',
      searchForClusterResults: 'searchForClusterResults',
      searchForSellers: 'searchForSellers',
      facetChanged
    }),
    ...mapMutations(CLASSIFIED_VIEW_NS, {
      setClassifiedId: SET_CLASSIFIED_ID
    }),
    ...mapMutations(CLASSIFIED_SEARCH_NS, {
      setParam: SET_PARAM,
      setShowSellers: SET_SHOW_SELLERS,
      setPage: SET_PAGE,
      setMapSearchFlag: SET_MAP_SEARCH_FLAG
    }),
    ...mapActions(CLASSIFIED_VIEW_NS, {
      navigateToClassifiedView: 'navigateToClassifiedView',
      setParked: 'setParked',
      loadClassifiedView: 'loadClassifiedView'
    }),
    ...mapActions(PAGE_NS, {
      addBodyClass: 'addBodyClass',
      removeBodyClass: 'removeBodyClass'
    }),
    ...mapActions(CLASSIFIED_SEARCH_NS, {
      search: 'search'
    }),

    showMap() {
      if (this.$refs.bottomDrawer) {
        this.$refs.bottomDrawer.collapseDrawer()
      }
    },
    async onMarkerClick({ marker }) {
      this.isCarouselItemVisible = true
      this.loadingClassified = true

      this.setClassifiedId(marker.id)

      await this.loadClassifiedView()
      this.loadingClassified = false
    },
    handleRowParkingStateChange({ isParked }) {
      this.setParked(isParked)
    },
    scrollResultsToTop(pixels: number = null) {
      const drawer = this.$refs.bottomDrawer
      this.$nextTick(() => drawer.scrollTo(0, pixels || drawer.top))
    },
    handleSelectedLocation(locationId: string) {
      this.search({
        pageView: true,
        updateUrl: true,
        extraParams: { location2: locationId } // @TODO check if location2 must be in config
      })
    },
    handlePostcodeChange(e) {
      this.postcode = e
      this.facetChanged({
        params: [
          { name: 'postcode', value: e.name },
          { name: 'country_code', value: e.country_code },
          { name: 'geolocation', value: null },
          { name: 'distance', value: 1000 }
        ]
      })
    },
    onClassifiedClick(payload) {
      const { classified, e, thumbData } = payload

      const { urlSlug } = classified
      this.slugOrId = `${classified.id}${urlSlug ? '-' + urlSlug : ''}`
      let navigateBaseUrl = '/'

      if (this.inPlotSearch) {
        navigateBaseUrl = '/plot/view/'
      }

      const refs = {
        categoryIds: thumbData.categoryIds || classified.categoryIds,
        id: thumbData.id || classified.id,
        isParked: thumbData.isParked || classified.isParked,
        thumb: thumbData.thumb || classified.thumb,
        title: thumbData.title || classified.title,
        price: thumbData.price || classified.price,
        salary: thumbData.salary || classified.salary,
        payment: thumbData.payment || classified.payment,
        thumbIndex: thumbData.thumbIndex || 0,
        offertype: thumbData.offertype || classified.offertype,
        hasPhotos: thumbData.hasPhotos || classified.hasPhotos,
        thumbsLength:
          thumbData.thumbsLength ||
          (classified.thumbs ? classified.thumbs.count : 0),
        externalLink: thumbData.externalLink || classified.externalLink,
        discount: classified.discount,
        goToMessagesOnLoad: false
      }

      if (refs.hasPhotos && classified.has_360photos) {
        // first index is always the 360 photo preview, so:
        refs.thumbIndex++
      }

      if (e && e.goToMessages) {
        refs.goToMessagesOnLoad = e.goToMessages
      }
      const element = this.$refs.bottomDrawer.$refs.drawer
      const spParamName = 'csp'
      this.navigateToClassifiedView({
        evt: e,
        url: navigateBaseUrl + this.slugOrId,
        setSp: true,
        refs,
        element,
        spParamName
      })
      this.setParam({ name: spParamName, value: element.scrollTop })
    },
    handleScrollToClassified(pixels: number) {
      if (this.$refs.bottomDrawer) {
        this.$refs.bottomDrawer.expandDrawer(pixels, 'auto')
      }
    },
    handleClusterWithMultipleClassifieds(cluster: ClusterMarker) {
      this.clusterGeolocation = cluster.rect
        .map(c => Object.values(c).join('x'))
        .join(',')
      this.isClusterResultsModalVisible = true
    },
    handleClosestLocation() {
      this.$refs.map.setLocationStatus()
    },
    handleSelectedSeller() {
      this.$refs.map.zoomToSeller()
    },
    setPostcodeData() {
      if (this.postcodeHandler?.values) {
        const {
          country_code: countryCode,
          postcode: name
        } = this.postcodeHandler.values.selected
        this.postcode.name = name
        this.postcode.country_code = countryCode
      }
    },
    handleMapClick() {
      this.isCarouselItemVisible = false
    },
    handleDrawerStatusChange(status: boolean) {
      this.isDrawerOpen = status
      if (this.params?.csp?.length && !status) {
        this.historyService.replaceQueryParams({ csp: null })
        this.setParam({ name: 'csp', value: null })
      }
    },
    toggleResultsModal(isVisible: boolean = true) {
      if (
        isVisible &&
        this.params?.['show-clusters']?.length &&
        this.params?.cgeolocation?.length
      ) {
        this.isClusterResultsModalVisible = true
      } else if (!isVisible) {
        this.isClusterResultsModalVisible = false
      }
    },
    onPopstate() {
      if (
        this.isDrawerOpen &&
        !this.params?.shop?.length &&
        !this.disablePopstate
      ) {
        this.handleDrawerStatusChange(false)
        this.$refs.bottomDrawer.collapseDrawer()
      }
      this.disablePopstate = false
    },
    async handlePageChange(pg: number) {
      if (process.client) {
        this.csp = null
        if (pg !== this.currentPage) {
          const newPageUrl = setUrlParam(
            `${window.location.pathname}${window.location.search}`,
            'pg',
            pg
          )
          await this.updateUrl(newPageUrl)
          this.updateRoutes()
          await this.changePage({ page: pg })
          if (this.hasParamShowSellers) {
            await this.searchForSellers({ loading: true, pageView: true })
          } else {
            await this.searchForResults({ loading: true, pageView: true })
          }
          this.scrollResultsToTop(-document.documentElement.clientHeight)
        }
      }
    }
  }
})
